var file_upload_viewer_default = {
  "fontElementMap": "ByRp-",
  "file_upload_container": "M9YbT",
  "file_upload_link": "tMDsd",
  "file_upload_error_container": "_6D0bi",
  "file_upload_file_info": "jnY9L",
  "file_upload_type_icon": "O6Rlr",
  "file_upload_status_icon_container": "J9jsA",
  "file_upload_status_icon": "_3ZGH4",
  "file_upload_description": "k5sdf",
  "file_upload_name_container": "o5T78",
  "file_upload_name": "VFEhk",
  "file_upload_extension": "CV9J-",
  "file_loader_icon": "el7OR",
  "file_upload_icon_frame": "WalO9",
  "file_upload_icon_background": "mLMXb"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
